const MOBILE_QUERY = "(width < 1024px)";
const REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";
const MAIN_SECTIONS_SELECTOR =
  ".site-main-section .shopify-section:not(.landing-page-menu-section)";

class LyleLandingPageMenu extends HTMLElement {
  #toggle = null;
  #list = null;
  #mobileQuery = null;
  #isOpen = false;

  connectedCallback() {
    this.#toggle = this.querySelector("[data-landing-page-menu-toggle]");
    this.#list = this.querySelector("[data-landing-page-menu-list]");
    this.#mobileQuery = window.matchMedia(MOBILE_QUERY);

    this.#toggle?.addEventListener("click", this.#handleToggle);
    this.#list?.addEventListener("click", this.#handleListClick);
    this.#mobileQuery.addEventListener("change", this.#handleBreakpointChange);
    document.addEventListener("keydown", this.#handleKeydown);
    document.addEventListener("click", this.#handleDocumentClick);
  }

  disconnectedCallback() {
    this.#toggle?.removeEventListener("click", this.#handleToggle);
    this.#list?.removeEventListener("click", this.#handleListClick);
    this.#mobileQuery?.removeEventListener(
      "change",
      this.#handleBreakpointChange,
    );
    document.removeEventListener("keydown", this.#handleKeydown);
    document.removeEventListener("click", this.#handleDocumentClick);
  }

  #handleBreakpointChange = () => {
    if (!this.#mobileQuery?.matches) {
      this.#reset();
    }
  };

  #handleToggle = () => {
    if (this.#isOpen) {
      this.#close();
    } else {
      this.#open();
    }
  };

  #handleListClick = (event) => {
    const anchorTrigger = event.target.closest(
      "[data-landing-page-menu-anchor]",
    );

    if (anchorTrigger) {
      event.preventDefault();
      this.#scrollToSection(anchorTrigger.dataset.landingPageMenuAnchor);
    }

    if (this.#isOpen) {
      this.#close();
    }
  };

  #handleKeydown = (event) => {
    if (event.key === "Escape" && this.#isOpen) {
      this.#close();
      this.#toggle?.focus();
    }
  };

  #handleDocumentClick = (event) => {
    if (this.#isOpen && !this.contains(event.target)) {
      this.#close();
    }
  };

  #open() {
    if (!this.#list) return;

    this.#isOpen = true;
    this.classList.add("is-open");
    this.#toggle?.setAttribute("aria-expanded", "true");
    this.#list.style.height = `${this.#list.scrollHeight}px`;
  }

  #close() {
    if (!this.#list) return;

    this.#isOpen = false;
    this.classList.remove("is-open");
    this.#toggle?.setAttribute("aria-expanded", "false");
    this.#list.style.height = "0px";
  }

  #reset() {
    this.#isOpen = false;
    this.classList.remove("is-open");
    this.#toggle?.setAttribute("aria-expanded", "false");

    if (this.#list) {
      this.#list.style.height = "";
    }
  }

  #scrollToSection(rawIndex) {
    const index = Number.parseInt(rawIndex, 10);

    if (!index || index < 1) return;

    const sections = document.querySelectorAll(MAIN_SECTIONS_SELECTOR);
    const target = sections[index - 1];

    if (!target) return;

    const headerOffset =
      Number.parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue(
          "--header-visible-height",
        ),
      ) || 0;

    const top = window.scrollY + target.getBoundingClientRect().top - headerOffset;
    const behavior = window.matchMedia(REDUCED_MOTION_QUERY).matches
      ? "auto"
      : "smooth";

    window.scrollTo({ top, left: 0, behavior });
  }
}

if (!customElements.get("lyle-landing-page-menu")) {
  customElements.define("lyle-landing-page-menu", LyleLandingPageMenu);
}
